/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import './ErrorScreen.scss';

const ErrorScreen: FunctionComponent = () => {
    return <div className="error-screen-container" />;
};

export default ErrorScreen;
